import lang from "translations";

export const CancelationReportColumns = [
  {
    key: "bookingId",
    text: lang.bookingId,
    custom: true,
    width: "w-3/12",
  
  },
  {
    key: "externalTicketId",
    text: lang.ticketNo,
    custom: true,
    width: "w-3/12",
  },
  {
    key:"createdAt",
    text:lang.date,
    custom: true,
    width: "w-3/12",
  },
  {
    key:"reason",
    text:lang.reason,
    custom: true,
    width: "w-3/12",
  }
];
